/**
 * Created by Jerker Nord on 2021-04-30.
 */

import {TrueGritStatics} from "../../TrueGritStatics";
import {SymbolUtils} from "../../utils/SymbolUtils";
import {ISymbol, ISymbolPosition} from "../../../core/reel/ReelInterfaces";
import {gsap, TimelineLite} from "gsap";
import {TrueGrit} from "../../TrueGrit";
import {TrueGritSymbol, TrueGritSymbolStates} from "../../reels/TrueGritSymbol";
import {TrueGritScatterSymbol} from "../../reels/TrueGritScatterSymbol";
import {TrueGritGritGirlSymbol} from "../../reels/TrueGritGritGirlSymbol";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {TrueGritModel} from "../../TrueGritModel";
import {TrueGritSound} from "../../sound/TrueGritSound";

export class TrueGritMainReelView extends PIXI.Container {

    private static SYMBOLS_FALL_DURATION:number = 0.5;
    private static SYMBOLS_UNBLUR_DURATION:number = 0.2;

    private readonly _reelId:number;

    private _allInSymbols:ISymbol[] = [];
    private _allOutSymbols:ISymbol[] = [];
    private _collapsedReel:ISymbol[] = [];
    private _symbolsOnReel:number;

    constructor(id:number) {
        super();

        this.name = "Reel " + id;
        this._reelId = id;
        this._symbolsOnReel = 4;
        if(this._reelId > 1) {
            this._symbolsOnReel = 3;
        }
        this.position = TrueGritStatics.reelPositions[id];

    }

    public clear(){

        while (this._allInSymbols.length > 0) {
            const sym = this._allInSymbols.pop();
            if (sym){
                this.removeAvalancheSymbol(sym);
            }
        }
        while (this._allOutSymbols.length > 0) {
            const sym = this._allOutSymbols.pop();
            if (sym){
                this.removeAvalancheSymbol(sym);
            }
        }
        while (this._collapsedReel.length > 0) {
            const sym = this._collapsedReel.pop();
            if (sym){
                this.removeAvalancheSymbol(sym);
            }
        }
    }


    public initReel(symbols:string[], isAvalancheRestore:boolean):void {
        for(let i:number = 1; i < (this._symbolsOnReel + 1); i++) {
            if(isAvalancheRestore == false) {
                const symbol:ISymbol = this.createSymbol(symbols[i], TrueGritSymbolStates.COLLAPSE_LANDING, {
                    reelId : this._reelId,
                    startPosition : (i - 1),
                    targetPosition : (i - 1)
                });
                this._allOutSymbols.push(symbol);
            } else {
                if(symbols[i] !== "X") {
                    const symbol:ISymbol = this.createSymbol(symbols[i], TrueGritSymbolStates.COLLAPSE_LANDING, {
                        reelId : this._reelId,
                        startPosition : (i - 1),
                        targetPosition : (i - 1)
                    });
                    symbol.reelPosition++;
                    symbol.reelTargetPosition++;
                    if(TrueGrit.model.initData.greatBookOfWays[this._reelId][i] > 1) {
                        (<TrueGritSymbol>symbol).splitLevel = TrueGrit.model.initData.greatBookOfWays[this._reelId][i];
                        (<TrueGritSymbol>symbol).setCurrentStateSpriteTexture();
                    }
                    this._collapsedReel.push(symbol);
                }
            }
        }
        this.moveScatterToTop(this._allOutSymbols);
        this.moveScatterToTop(this._collapsedReel);
    }

    private moveScatterToTop(symbols:ISymbol[]):void {
        for(let i:number = 0; i < symbols.length; i++) {
            if(symbols[i].symbolName == "S") {
                this.addChild(<TrueGritSymbol>symbols[i]);
            }
        }
    }

    public getSymbol(position:number):ISymbol {
        position--;
        return this._allOutSymbols[position];
    }

    public getAllSymbols():ISymbol[] {
        return this._allOutSymbols;
    }

    public createSymbol(symbolName:string, state:TrueGritSymbolStates, symbolPositionData:ISymbolPosition):ISymbol {
        const symbol:TrueGritSymbol = SymbolUtils.createSymbol(symbolName, state, symbolPositionData);
        symbol.position.set(0, symbolPositionData.startPosition * TrueGritStatics.symbolHeight);
        symbol.reelTargetPosition = symbolPositionData.targetPosition;
        symbol.reelPosition = symbolPositionData.startPosition;
        symbol.reelId = symbolPositionData.reelId;
        this.addChild(symbol);
        return symbol;
    }

    public getAllOutAnimation():TimelineLite {
        const returnTimeline:gsap.core.Timeline = gsap.timeline();
        let timeline:gsap.core.Timeline;
        const subTimelines:gsap.core.Timeline[] = [];
        let counter:number = 0;
        while(this._allOutSymbols.length > 0) {
            const symbol:TrueGritSymbol = <TrueGritSymbol>this._allOutSymbols.pop()!;
            symbol.reelTargetPosition = 5;
            if(symbol == null) {
                debugger;
                throw new Error(`AvalancheReelPartAnimator.animateAllOut, symbol is null!`);
            } else {
                timeline = gsap.timeline();
                timeline.add([
                    gsap.timeline({delay : TrueGrit.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? TrueGritStatics.mainReelAllOutBlurDelayFastSpin + (counter * 0.03) : (TrueGritStatics.mainReelAllOutBlurDelay + (counter * 0.01))}).add((<TrueGritSymbol>symbol).getStateAnimation(TrueGritSymbolStates.SPIN_OUT, 0.1)),
                    gsap.to(symbol.position, {
                        duration : TrueGrit.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? TrueGritStatics.mainReelAllOutTotalSpinDurationFastSpin : TrueGritStatics.mainReelAllOutTotalSpinDuration,
                        y : TrueGritStatics.symbolHeight * (symbol.reelTargetPosition - 1) + 60,
                        ease : "sine.in",
                        delay : TrueGritStatics.mainReelSpinStartSymbolDelay * counter
                    })
                ]);
                timeline.add(() => this.removeAvalancheSymbol(symbol));
                subTimelines.push(timeline);
            }
            counter++;
        }
        returnTimeline.add(subTimelines);
        return returnTimeline;
    }

    public getFillUpReelAnimation(cb:() => void):gsap.core.Timeline {
        const numberOfFillUpSymbols:number = this._symbolsOnReel - this._collapsedReel.length;
        for(let i:number = 0; i < numberOfFillUpSymbols; i++) {
            const symbol:ISymbol = this.createSymbol(TrueGrit.model.gameData.reels[this._reelId][i + 1], TrueGritSymbolStates.SPIN_IN, {
                reelId : this._reelId,
                startPosition : (0 - ((numberOfFillUpSymbols - i) + 1)),
                targetPosition : i + 1
            });
            this._collapsedReel.push(symbol);
        }
        this.moveScatterToTop(this._collapsedReel);
        return this.getFillUpAnimation(cb);
    }

    private getFillUpAnimation(cb:() => void):gsap.core.Timeline {
        const fillUpTimeline:gsap.core.Timeline = gsap.timeline({
            onComplete : () => cb()
        });
        let timeline:gsap.core.Timeline;
        const subTimelines:gsap.core.Timeline[] = [];
        let counter:number = 0;
        this._allOutSymbols = [];
        let highestTargetPosition:number = 0;
        let nearWinDelay:number = 0;
        if(TrueGrit.model.gritGirlNearWinReels[this._reelId] || TrueGrit.model.scatterNearWinReels[this._reelId]) {
            nearWinDelay = TrueGritStatics.nearWinSpinInGapDelay;
        }
        for(let i:number = 0; i < this._collapsedReel.length; i++) {
            if(this._collapsedReel[i].reelTargetPosition > this._collapsedReel[i].reelPosition) {
                if(this._collapsedReel[i].reelTargetPosition > highestTargetPosition) {
                    highestTargetPosition = this._collapsedReel[i].reelTargetPosition;
                }
            }
        }

        let firstSymbol:boolean = true;
        while(this._collapsedReel.length > 0) {
            const symbol:ISymbol = this._collapsedReel.pop()!;
            this._allOutSymbols.push(symbol);
            if(symbol == null) {
                debugger;
                throw new Error(`AvalancheReelPartAnimator.animateFillUp, symbol is null!`);
            } else {
                if(symbol.reelTargetPosition > symbol.reelPosition) {
                    timeline = gsap.timeline();
                    timeline.add([
                        gsap.timeline({delay : TrueGritMainReelView.SYMBOLS_UNBLUR_DURATION}).add((<TrueGritSymbol>symbol).getStateAnimation(TrueGritSymbolStates.LANDING, TrueGritMainReelView.SYMBOLS_UNBLUR_DURATION)),
                        gsap.to(symbol.position, {
                            duration : TrueGritMainReelView.SYMBOLS_FALL_DURATION,
                            y : TrueGritStatics.symbolHeight * (symbol.reelTargetPosition - 1) + 1, // #363, #437
                            ease : "power3.in",
                            delay : (TrueGrit.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? TrueGritStatics.mainReelSpinStopSymbolDelayFastSpin : TrueGritStatics.mainReelSpinStopSymbolDelay) + nearWinDelay
                        })
                    ]);

                    // #462
                    if(firstSymbol) {
                        firstSymbol = false;
                        timeline.add(() => TrueGrit.anticipationView.tryAnticipation(this._reelId));
                    }

                    // #363, #437
                    timeline.add(gsap.to(symbol.position, {
                        duration : 0.03,
                        y : TrueGritStatics.symbolHeight * (symbol.reelTargetPosition - 1) - 2,
                        ease : "none"
                    }));

                    // #437 trigger sound now
                    if(symbol.reelTargetPosition == highestTargetPosition || nearWinDelay > 0) {
                        timeline.add(() => this.symbolLandingSounds(symbol, true));
                    } else {
                        timeline.add(() => this.symbolLandingSounds(symbol, false));
                    }

                    // #363, #437
                    timeline.add(gsap.to(symbol.position, {
                        duration : 0.05,
                        y : TrueGritStatics.symbolHeight * (symbol.reelTargetPosition - 1),
                        ease : "none"
                    }));

                    if(symbol.reelTargetPosition == highestTargetPosition || nearWinDelay > 0) {
                        timeline.add(() => this.symbolLanding(symbol), "+=0.1");
                    } else {
                        timeline.add(() => this.symbolLanding(symbol), "+=0.1");
                    }
                    timeline.add(() => {symbol.reelPosition = symbol.reelTargetPosition});
                    subTimelines.push(timeline);
                }
            }
            counter++;
        }
        fillUpTimeline.add(subTimelines);
        fillUpTimeline.add(() => {
            if(this._reelId === TrueGritModel.lastActiveReelInFirst4) {
                TrueGrit.anticipationView.stopAnticipationSounds();
            }
        });
        fillUpTimeline.add(() => {this._allOutSymbols = this.sortSymbolArray(this._allOutSymbols)});
        //fillUpTimeline.add(() => this.reelSanityCheck());
        return fillUpTimeline;
    }

    /**
     * Calculates which symbols that should fall down and how many steps
     */
    public collapseReel():gsap.core.Timeline {
        this._collapsedReel = [];
        for(let i:number = this._allOutSymbols.length - 1; i > -1; i--) {
            if(this._allOutSymbols[i].isRemoved == true) {
                // If i = 0 it's the top symbol which can't fall down
                if(i > 0) {
                    for(let j:number = i; j > 0; j--) {
                        if(this._allOutSymbols[j - 1].isRemoved == false) {
                            this._allOutSymbols[j - 1].reelTargetPosition++;
                        }
                    }
                }
            } else {
                this._collapsedReel.push(this._allOutSymbols[i]);
            }
        }
        return this.getCollapseAnimation();
    }

    private getCollapseAnimation():gsap.core.Timeline {
        const collapseTimeline:gsap.core.Timeline = gsap.timeline();
        let timeline:gsap.core.Timeline;
        const subTimelines:gsap.core.Timeline[] = [];
        let highestTargetPosition:number = 0;

        for(let i:number = 0; i < this._allOutSymbols.length; i++) {
            if(this._allOutSymbols[i].reelTargetPosition > this._allOutSymbols[i].reelPosition) {
                if(this._allOutSymbols[i].reelTargetPosition > highestTargetPosition) {
                    highestTargetPosition = this._allOutSymbols[i].reelTargetPosition;
                }
            }
        }
        this._allOutSymbols.reverse();
        for(let i:number = 0; i < this._allOutSymbols.length; i++) {
            const symbol:TrueGritSymbol = <TrueGritSymbol>this._allOutSymbols[i];
            if(symbol == null) {
                debugger;
                throw new Error(`AvalancheReelPartAnimator.collapseAnimation, symbol is null!`);
            } else {
                if(symbol.reelTargetPosition > symbol.reelPosition) {
                    timeline = gsap.timeline()
                    timeline.add(symbol.animateCollapse());
                    if(symbol.reelTargetPosition == highestTargetPosition) {
                        timeline.add(() => {
                            this.symbolLandingSounds(symbol, true, true);
                        });
                    } else {
                        timeline.add(() => {
                            this.symbolLandingSounds(symbol, false, true);
                        });
                    }

                    timeline.add(() => {symbol.reelPosition = symbol.reelTargetPosition});
                    subTimelines.push(timeline);
                }
            }
        }
        this._allOutSymbols.reverse();

        collapseTimeline.add(subTimelines);

        if(collapseTimeline.duration() == 0) {
            collapseTimeline.add(gsap.to(this, {duration : 0.001}));
        }

        return collapseTimeline;
    }

    public getAllInAnimation():gsap.core.Timeline {
        const returnTimeline:gsap.core.Timeline = gsap.timeline();
        let timeline:gsap.core.Timeline;
        const subTimelines:gsap.core.Timeline[] = [];
        let counter:number = 0;
        let nearWinDelay:number = 0;
        if(TrueGrit.model.gritGirlNearWinReels[this._reelId] || TrueGrit.model.scatterNearWinReels[this._reelId]) {
            nearWinDelay = TrueGritStatics.nearWinSpinInGapDelay;
        }
        this._allOutSymbols = [];

        let firstSymbol:boolean = true;
        while(this._allInSymbols.length > 0) {
            const symbol:ISymbol = this._allInSymbols.pop()!;
            this._allOutSymbols.unshift(symbol);
            if(symbol == null) {
                debugger;
                throw new Error(`AvalancheReelPartAnimator.animateAllIn, symbol is null!`);
            } else {
                timeline = gsap.timeline();

                const fastSpin:boolean = (TrueGrit.apiPlugin.settings.get(APISetting.FAST_SPIN, false));
                const totalSpinDuration = fastSpin ? TrueGritStatics.mainAllInTotalSpinDurationFastSpin : TrueGritStatics.mainAllInTotalSpinDuration;
                const symSpinStopDuration = fastSpin ? TrueGritStatics.mainReelSpinStopSymbolDelayFastSpin : TrueGritStatics.mainReelSpinStopSymbolDelay;
                const landingDelay = totalSpinDuration + (symSpinStopDuration + nearWinDelay);

                timeline.add([
                    gsap.timeline({delay : fastSpin ? TrueGritStatics.mainReelAllInBlurDelayFastSpin + (counter * 0.03) : (TrueGritStatics.mainReelAllInBlurDelay + (counter * 0.01))}).add((<TrueGritSymbol>symbol).getStateAnimation(TrueGritSymbolStates.LANDING, 0.1)),
                    gsap.to(symbol.position, {
                        duration : totalSpinDuration,
                        y : TrueGritStatics.symbolHeight * (symbol.reelTargetPosition - 1) + 2, // #363, #437
                        ease : "power3.in",
                        delay : symSpinStopDuration + nearWinDelay
                    }),

                    gsap.timeline({delay : landingDelay}).add(() => {
                        this.symbolLandingSounds(symbol, nearWinDelay > 0);
                        this.symbolLanding(symbol);
                    }),
                ]);

                // #462
                if(firstSymbol) {
                    firstSymbol = false;
                    timeline.add(() => TrueGrit.anticipationView.tryAnticipation(this._reelId));
                }

                // #363, #437
                timeline.add(gsap.to(symbol.position, {
                    duration : (totalSpinDuration * 0.08),
                    y : TrueGritStatics.symbolHeight * (symbol.reelTargetPosition - 1) - 3,
                    ease : "power3.in"
                }));
                timeline.add(gsap.to(symbol.position, {
                    duration : (totalSpinDuration * 0.12),
                    y : TrueGritStatics.symbolHeight * (symbol.reelTargetPosition - 1),
                    ease : "power3.in"
                }));

                timeline.add(() => {symbol.reelPosition = symbol.reelTargetPosition});
                subTimelines.push(timeline);
            }
            counter++;
        }
        returnTimeline.add(subTimelines);
        returnTimeline.add(() => {
            if(this._reelId === TrueGritModel.lastActiveReelInFirst4) {
                TrueGrit.anticipationView.stopAnticipationSounds();
            }
        });
        return returnTimeline;
    }

    // #437
    private symbolLandingSounds(symbol:ISymbol, playLandingSound:boolean, calledFromCollapse:boolean = false):void {
        if(((this._reelId < 2 && symbol.reelTargetPosition == 4) || (this._reelId > 1 && symbol.reelTargetPosition == 3)) || playLandingSound == true) {
            TrueGrit.soundPlayer.playRandomReelStopSound();
        }
        //Making sure blur is off
        if(symbol.symbolName !== "S") {
            (<TrueGritSymbol>symbol).getStateAnimation(TrueGritSymbolStates.LANDING);
        }

        if(symbol.symbolName === "M0" && !calledFromCollapse) {
            if(!TrueGrit.model.botTrain.isRevealed[0] && this._reelId === 3 && symbol.reelTargetPosition == 3) {
                //Grit girl landed in locked position
            } else {
                (<TrueGritGritGirlSymbol>symbol).playGritGirlLandedAnimation();
            }
        } else if(symbol.symbolName !== "S") {
            if(symbol.symbolName == "M" && TrueGrit.model.unlockedPositions?.matrix[symbol.reelId][symbol.reelTargetPosition]) {
                TrueGrit.soundPlayer.playSound(TrueGritSound.XWAYS_LANDING);
            }
        }
    }

    private symbolLanding(symbol:ISymbol):void {
        if(symbol.symbolName == "S") {
            if(TrueGrit.model.botTrain.isRevealed[0] == false && this._reelId == 3 && symbol.reelTargetPosition == 3) {
                //Scatter landed in locked position
            } else {
                (<TrueGritScatterSymbol>symbol).playScatterLandedAnimation();
            }
        }
    }

    public stop(reelData:string[]):TimelineLite {
        for(let i:number = 1; i < (this._symbolsOnReel + 1); i++) {
            const symbol:ISymbol = this.createSymbol(reelData[i], TrueGritSymbolStates.SPIN_IN, {
                reelId : this._reelId,
                startPosition : (0 - ((this._symbolsOnReel - i) + 1)),
                targetPosition : i
            });
            this._allInSymbols.push(symbol);
        }
        this.moveScatterToTop(this._allInSymbols);
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(this.getAllInAnimation());

        return tl;
    }

    private sortSymbolArray(toBeSorted:ISymbol[]):ISymbol[] {
        const sortedSymbols:ISymbol[] = [];
        //Sorting symbols with reelposition 1-4 (position 0 is top reel)
        for(let i:number = 1; i < 5; i++) {
            for(let j:number = 0; j < toBeSorted.length; j++) {
                if(toBeSorted[j].reelPosition == i) {
                    sortedSymbols.push(toBeSorted[j]);
                    break;
                }
            }
        }
        return sortedSymbols;
    }

    public removeAvalancheSymbol(symbol:ISymbol) {
        this.removeChild(<TrueGritSymbol>symbol);
        if(symbol.symbolName == "S") {
            (<TrueGritScatterSymbol>symbol).reset();
        } else if(symbol.symbolName.indexOf("M0") > -1) {
            (<TrueGritGritGirlSymbol>symbol).reset();
        } else {
            (<TrueGritSymbol>symbol).destroy({children : true});
        }
    }
}